var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applet-contain"},[_c('p',{staticClass:"title"},[_vm._v("单次购买-"+_vm._s(_vm.target.name))]),[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.item.createdAt))+"创建的订单")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }